const statusColors: Record<string, string> = {
  // Project statuses
  draft: 'bg-slate-100 text-slate-600',
  active: 'bg-emerald-100 text-emerald-800',
  completed: 'bg-blue-100 text-blue-800',
  // Ask statuses
  open: 'bg-emerald-100 text-emerald-800',
  partially_fulfilled: 'bg-amber-100 text-amber-800',
  fulfilled: 'bg-blue-100 text-blue-800',
  cancelled: 'bg-gray-100 text-gray-600',
  // Transaction statuses
  pledged: 'bg-purple-100 text-purple-800',
  shipped: 'bg-sky-100 text-sky-800',
  delivered: 'bg-indigo-100 text-indigo-800',
  received: 'bg-teal-100 text-teal-800',
  verified: 'bg-emerald-100 text-emerald-800',
  // User statuses
  pending: 'bg-amber-100 text-amber-800',
  approved: 'bg-emerald-100 text-emerald-800',
  rejected: 'bg-red-100 text-red-800',
  suspended: 'bg-gray-100 text-gray-600',
};

const statusLabels: Record<string, string> = {
  draft: 'Draft',
  active: 'Active',
  completed: 'Completed',
  open: 'Open',
  partially_fulfilled: 'Partial',
  fulfilled: 'Fulfilled',
  cancelled: 'Cancelled',
  pledged: 'Pledged',
  shipped: 'Shipped',
  delivered: 'Delivered',
  received: 'Received',
  verified: 'Verified',
  pending: 'Pending',
  approved: 'Approved',
  rejected: 'Rejected',
  suspended: 'Suspended',
};

export function StatusBadge({ status }: { status: string }) {
  const label = statusLabels[status] || status;
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ${statusColors[status] || 'bg-gray-100 text-gray-600'}`}>
      {label}
    </span>
  );
}
